import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efdadba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block font-semibold text-lg tracking-wide" }, "Invite account member", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block text-sm font-light pt-5 w-5/6 tracking-wide" }, " Add members to your team and do more with Axelerate together! Teams make it easier to divide responsibilities and keep everything under one roof. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-px bg-gray-200" })
], -1))
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "pt-2" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col w-full pt-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Roles:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full space-x-3 py-2" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvitesList = _resolveComponent("InvitesList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_InvitesList)
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}